<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lbyd72/tc-custom/9781429988001.jpg?1735616730385" alt="This image is the cover for the book Searching for Beauty"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Searching for Beauty
      </h1>
      <p class="bookDescription body article font2">
        <b>A fascinating portrait of the Standard Oil heiress and legendary American trendsetter Millicent Rogers.</b><br/><br/><b>“A page-turning tale of a society rebel.” —Meryl Gordon, author of <i>Mrs. Astor Regrets</i></b><br/><br/>Nobody knew how to live the high life like Standard Oil heiress Millicent Rogers. Born into luxury, she lived in a whirl of beautiful homes, European vacations, exquisite clothing, and handsome men.<br/><br/>In <i>Searching for Beauty</i>, Cherie Burns chronicles Rogers’s glittering life from her days as a young girl afflicted with rheumatic fever to her moment as a glittering debutante, through her years as an American aristocrat abroad, and ending with her final days as one of the legendary chatelaines of Taos, New Mexico.<br/><br/>A rebellious icon of the age, she eloped with a penniless baron; danced tangos in European nightclubs; divorced, remarried, and romanced, among other, the writer Roald Dahl, Secretary of Defense James Forrestal, and Hollywood icon Clark Gable. Her romantic conquests, though, paled in comparison to her triumph in the world of fashion where her unerring sense of style and her ability to mix the high with the low brought her to the attention of the fashionistas of the day. She became the muse to legendary American designer Charles James, appeared in <i>Vogue</i> and <i>Harper’s Bazaar</i>, and popularized Southwestern style by adopting turquoise jewelry, squaw skirts, and short-waist jackets as her signature look.<br/><br/>With <i>Searching for Beauty</i>, Millicent Rogers enters the pantheon of great American women who, like Diana Vreeland and Babe Paley, put their distinctive stamp on American style.<br/><br/><b>“A glittering tale of . . . one of the most glamorous women of the twentieth century. Anyone who is interested in the annals of high society will be fascinated with this book. . . . An intimate and deeply personal view of Millicent Rogers, her family and her unending search for love and beauty.” —Adam Lewis, author of<i> The Great Lady Decorators</i>,<i> Billy Baldwin</i>,<i> Albert Hadley</i>,<i></i>and<i> Van Day Truex</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cherie Burns
      </h2>
      
      <p class="authorDescription body article"><P>CHERIE BURNS is the author of <I>The Great Hurricane: 1938</I>. Her work has also appeared in The New York Times Magazine, People, Glamour, New York, and other publications. She lives in Taos, New Mexico.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7cf09b17